import React, { useState } from "react";
import { Actions as AUTHENTICATIONACTIONS } from "../../../store/actions/authenticationActions";
import { connect } from "react-redux";
import { PaperAirplaneIcon, SparklesIcon, UserCircleIcon } from "@heroicons/react/20/solid";
import { ArrowRightOnRectangleIcon } from "@/icons/outline";
import { useMemo } from "react";
import { ClipboardIcon } from "@/icons/solid";
import { copyToClipboard } from "@/helpers/ClipboardHelpers";

const OptionsBtn = ({ logout, userName, isAdmin, userId, org }) => {
	const [open, setOpen] = useState(false);
	const greetings = [
		"Hello,",
		"What's up,",
		"How's it going,",
		"Hi,",
		"Hey,",
		"Welcome,",
		"Greetings,",
		"Howdy,",
		"Bonjour,",
		"Hola,",
		"Ciao,",
		"Namaste,",
		"Salaam,",
		"Aloha,",
		"Merħba,",
		"Olá,",
	];

	const randomGreeting = useMemo(() => {
		return greetings[Math.floor(Math.random() * greetings.length)];
	}, [userName]);

	return (
		<div className={`btn-group${open ? " open" : ""}`}>
			<button
				className="btn btn-default dropdown-toggle"
				data-toggle="dropdown"
				type="button"
				aria-expanded={open}
				onClick={() => setOpen(!open)}
			>
				<UserCircleIcon style={{ height: "1.5em", float: "left", marginRight: "0.5rem" }} />
				{randomGreeting} {userName}!
				<span
					className="caret"
					style={{ marginLeft: "0.5rem" }}
				></span>
			</button>
			<ol className="dropdown-menu dropdown-menu-right">
				{/* <li>
                <a tabIndex="-1" href="https://app.stage.buddy.hr/dashboard"><i className="si si-compass pull-right" />Become an Advisor</a>
            </li>
            <li className="divider"></li> */}
				{isAdmin ? (
					<li>
						<a
							tabIndex="-1"
							href="#"
							onClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
								copyToClipboard(userId);
							}}
						>
							<ClipboardIcon
								style={{ height: "1.25em", float: "right", marginLeft: 10, color: "gray" }}
							/>
							<span>Copy User ID</span>
						</a>
					</li>
				) : null}
				<li>
					<a
						tabIndex="-1"
						href="https://employee.buddy.hr/"
					>
						<PaperAirplaneIcon
							style={{ height: "1.25em", float: "right", marginLeft: 10, color: "gray" }}
						/>
						<span>Switch to Employee</span>
					</a>
				</li>
				<li>
					<a
						tabIndex="-1"
						href={window.location.origin}
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();

							const urlParams = new URLSearchParams(window.location.search);
							let link = window.location.href;

							if (!document.URL.includes("/advisor")) {
								link += `${urlParams.toString() ? "&" : "?"}` + "organisation=" + org;
							}

							copyToClipboard(link);
						}}
					>
						<SparklesIcon style={{ height: "1.25em", float: "right", marginLeft: 10, color: "gray" }} />
						<span>Copy Magic Link</span>
					</a>
				</li>
				<li>
					<a
						tabIndex="-1"
						href={window.location.origin}
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
							logout();
						}}
					>
						<ArrowRightOnRectangleIcon
							style={{ height: "1.25em", float: "right", marginLeft: 10, color: "gray" }}
						/>
						<span>Log out</span>
					</a>
				</li>
			</ol>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		userName: state.my?.profile?.givenName,
		isAdmin: state.my?.profile?.isAdmin,
		userId: state.my?.profile?.id,
		org: state.company?.settings?.org,
	};
};

const mapDispatchToProps = (dispatch) => ({
	logout: () => dispatch(AUTHENTICATIONACTIONS.logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OptionsBtn);
